export const cropperConfig: Cropper.Options = {
    aspectRatio: 1,
    minCropBoxHeight: 150,
    minCropBoxWidth: 150,
    minContainerWidth: 450,
    minContainerHeight: 450,
    viewMode: 2,
    zoomable: false,
};
